/* eslint-disable no-underscore-dangle */
import { request } from '../../utils/api';
import { ORDER_URL } from '../../utils/constants';
import {
    clearItems,
    getOrderFailed,
    getOrderRequest,
    getOrderSuccess,
    getOrderDetailsSuccess,
} from '../actions';
import { TIngredientType, TOrderData, TwsOrder } from '../../utils/types';
import { AppThunk } from '../../utils/store-types';

type TOrderDetailsRequest = { success: boolean; orders: [TwsOrder] };

export function getOrder(
    bun: TIngredientType,
    ingredients: Array<TIngredientType>
): AppThunk {
    return (dispatch) => {
        dispatch(getOrderRequest());
        const { accessToken } = localStorage;
        if (accessToken)
            request<TOrderData>(ORDER_URL, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${accessToken}`,
                },
                body: JSON.stringify(
                    bun
                        ? {
                              ingredients: [
                                  bun._id,
                                  ...ingredients.map((i) => i._id),
                                  bun._id,
                              ],
                          }
                        : {
                              ingredients: [...ingredients.map((i) => i._id)],
                          }
                ),
            })
                .then((data) => {
                    dispatch(getOrderSuccess(data));
                    dispatch(clearItems());
                })
                .catch((err) => {
                    dispatch(getOrderFailed(err));
                });
    };
}
export function getOrderDetails(id: number): AppThunk {
    return (dispatch) => {
        request<TOrderDetailsRequest>(`${ORDER_URL}/${id}`, {})
            .then((data) => {
                if (data.success)
                    dispatch(getOrderDetailsSuccess(data.orders[0]));
            })
            .catch(() => {});
    };
}
export default getOrder;
